"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMemoryGrowTimestamp = exports.getInstance = void 0;

var load_1 = require("./load");

var inst = null;
var HEAP32 = new Int32Array();

var clock_gettime = function clock_gettime(clk_id, tp) {
  var now = Date.now();
  HEAP32[tp >> 2] = now / 1e3 | 0;
  HEAP32[tp + 4 >> 2] = now % 1e3 * 1e3 * 1e3 | 0;
  return 0;
};

var lastGrowTimestamp = 0;

var emscripten_notify_memory_growth = function emscripten_notify_memory_growth(idx) {
  if (lastGrowTimestamp) {
    console.info('zbar.wasm: Memory Grow: ', inst.memory.buffer.byteLength);
  }

  lastGrowTimestamp = Date.now();
  HEAP32 = new Int32Array(inst.memory.buffer);
};

var importObj = {
  env: {
    clock_gettime: clock_gettime,
    emscripten_notify_memory_growth: emscripten_notify_memory_growth
  }
};

var instPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var res;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return load_1.loadWasmInstance(importObj);

        case 2:
          res = _context.sent;

          if (res) {
            _context.next = 5;
            break;
          }

          throw Error('WASM was not loaded');

        case 5:
          inst = res.exports;
          emscripten_notify_memory_growth(0);
          return _context.abrupt("return", inst);

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}))();

exports.getInstance = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return instPromise;

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
}));

exports.getMemoryGrowTimestamp = function () {
  return lastGrowTimestamp;
};